import { Link } from "react-router-dom";
import type { VideoItem } from "@/mocks/videos";
import { formatCount } from "@/lib/format";

interface RelatedListProps {
  videos: VideoItem[];
}

export default function RelatedList({ videos }: RelatedListProps) {
  return (
    <div className="rounded-xl border border-background-200 bg-background-50 p-4 md:p-5">
      <h2 className="text-base font-bold text-foreground-950 mb-4 flex items-center gap-2">
        <i className="ri-movie-line text-accent-500"></i>
        相关推荐
      </h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-1 gap-4">
        {videos.map((video) => (
          <Link
            key={video.id}
            to={`/detail/${video.id}`}
            className="group flex gap-3 cursor-pointer"
          >
            <div className="relative w-[140px] h-[84px] shrink-0 rounded-lg overflow-hidden bg-background-200">
              <img
                src={video.cover}
                alt={video.title}
                title={`${video.title} - 快手短视频`}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              <span className="absolute bottom-1.5 right-1.5 px-1 py-0.5 rounded bg-foreground-950/75 text-background-50 text-xs">
                {video.duration}
              </span>
            </div>
            <div className="flex-1 min-w-0">
              <h3 className="text-sm font-medium text-foreground-900 leading-snug line-clamp-2 group-hover:text-accent-600 transition-colors">
                {video.title}
              </h3>
              <p className="text-xs text-foreground-500 mt-1.5 line-clamp-1">{video.author}</p>
              <p className="text-xs text-foreground-400 mt-1 flex items-center gap-1">
                <i className="ri-play-circle-line"></i>
                {formatCount(video.views)} 播放
              </p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}